import { useState } from "react";
import { FalloutCharacter, FalloutCharacterStatus, RequestMoveCharacter } from "../Data/Response";

interface MoveCharacterModalViewArgs {
    character: FalloutCharacter;
    maxStandardMovement: number;
    maxHurryingMovement?: number;
    submitMoveCharacter: (request: RequestMoveCharacter) => void;
    enemyCharacters?: FalloutCharacter[];
}

const MoveCharacterModalView: React.FC<MoveCharacterModalViewArgs> = args => {
    var [x, setX] = useState(0);
    var [y, setY] = useState(0);
    var [z, setZ] = useState(0);
    var [distance, setDistance] = useState(0);
    var [newlyEngagedCharacterIds, setNewlyEngagedCharacterIds] = useState<string[]>([]);

    return < div >
        <h2>Move Your Character!</h2>
        <p>Moving {args.character.name}</p>
        <p>Standard Max Distance: {args.maxStandardMovement}</p>
        <p>Hurrying Max Distance: {args.maxHurryingMovement ?? "Not available: Too fatigued"}</p>
        <ul>
            <li>
                <input
                    type="number"
                    id="moveCharacterXInput"
                    value={x}
                    onChange={e => {
                        setX(parseInt(e.target.value));
                    }}
                />
                <label htmlFor="moveCharacterXInput">X</label>
            </li>
            <li>
                <input
                    type="number"
                    id="moveCharacterYInput"
                    value={y}
                    onChange={e => {
                        setY(parseInt(e.target.value));
                    }}
                />
                <label htmlFor="moveCharacterYInput">Y</label>
            </li>
            <li>
                <input
                    type="number"
                    id="moveCharacterZInput"
                    value={z}
                    onChange={e => {
                        setZ(parseInt(e.target.value));
                    }}
                />
                <label htmlFor="moveCharacterZInput">Z</label>
            </li>
            <li>
                <input
                    type="number"
                    id="moveCharacterDistanceInput"
                    value={distance}
                    onChange={e => {
                        setDistance(parseInt(e.target.value));
                    }}
                />
                <label htmlFor="moveCharacterDistanceInput">Distance</label>
            </li>
        </ul>
        <h3>Newly Engaged Enemies</h3>
        {args.enemyCharacters && <ul>
            {args.enemyCharacters.map(e => {
                if (e.state.status !== "active") {
                    return;
                }
                const htmlId = `MoveCharacterEngagement${e.id}`;
                return <li>
                    <input
                        type="checkbox"
                        id={htmlId}
                        checked={newlyEngagedCharacterIds.includes(e.id)}
                        onChange={ev => {
                            setNewlyEngagedCharacterIds(prev => {
                                return ev.target.checked ? [...prev, e.id] : prev.filter(id => id !== e.id);
                            })
                        }}
                    />
                    <label htmlFor={htmlId}>{e.name}</label>
                </li>
            })}
        </ul>}
        <button
            onClick={async e => {
                args.submitMoveCharacter({
                    CharacterId: args.character.id,
                    DistanceInInches: distance,
                    EngagedCharacterIds: newlyEngagedCharacterIds,
                    Path: [{ X: x, Y: y, Z: z }],
                    Rotation: { X: 1, Y: 1, Z: 1, W: 1 }
                });
            }}
        >Move!</button>
    </div>;
}

export default MoveCharacterModalView;